import React from "react";
import DaySelector from "./DaySelector/DaySelector";
import HourSelector from "./HourSelector/HourSelector";
import InputErrorMessage from "../InputErrorMessage/InputErrorMessage";
import "./DayAndHourSelector.css";

const DayAndHourSelector = (props) => {
  return (
    <div className="day-and-hour-selector">
      <div>
        {props.checkedDaysError !== "" ? (
          <InputErrorMessage errorText={props.checkedDaysError} />
        ) : null}
        <DaySelector
          daySelectorName={props.daySelectorName}
          daysValue={props.daysValue}
          handleCheckboxClick={props.handleDayCheckboxClick}
          days={props.days}
          handleCheckboxOnChange={props.handleDayCheckboxOnChange}
          zIndexValue={props.zIndexValue - 1}
        />
      </div>

      <div>
        {props.checkedHoursError !== "" ? (
          <InputErrorMessage errorText={props.checkedHoursError} />
        ) : null}
        <HourSelector
          hourSelectorName={props.hourSelectorName}
          hoursValue={props.hoursValue}
          handleCheckboxClick={props.handleHourCheckboxClick}
          hours={props.hours}
          handleCheckboxOnChange={props.handleHourCheckboxOnChange}
          zIndexValue={props.zIndexValue - 2}
        />
      </div>
    </div>
  );
};

export default DayAndHourSelector;
